import { css } from "lit";
import { Style } from "../Styles";

export const styles = css`
    ${Style}
    .settings-container {
        width: 100%;
        padding-top: 1em;
    }

    .settings-container sl-button {
        display: block;
        flex: 1;
    }

    .settings-container sl-card {
        flex: 1;
    }

    .settings-container span {
        padding-top: 1em;
    }

    .settings-tools {
        padding-top: 1em;
    }

    sl-select::part(form-control-label) {
        padding-bottom: 0.5em;
        padding-top: 1em;
    }

    sl-button sl-icon {
        margin-right: 0.5em;
    }

    sl-button::part(base) {
        justify-content: left;
        background-color: transparent;
        border-color: transparent;
        font-weight: unset;
        font-size: 1.1em;
    }

    sl-button a {
        text-decoration: unset;
        font-weight: unset;
        color: black;
    }
`;
